export default {
  common: {
    signOut: 'Logout'
  },
  views: {
    login: {
      memberId: 'Member ID',
      birthday: 'Date of Birth',
      signIn: 'Login',
      invalidLogin: 'Member ID or Date of Birth is incorrect'
    },
    memberInfo: {
      information: 'Member Information',
      memberType: 'Membership Type',
      memberID: 'Member ID',
      validity: 'Validity Period',
      useHistory: 'Usage History',
      ticketUsage: 'Ticket Usage',
      logout: 'Logout'
    }
  },
  validation: {
    required: 'Please enter {{name}}',
    requiredSelect: 'Please select',
    invalid: 'Please enter a valid {{name}}',
    password:
      'Please set a password of 8 characters or more, combining uppercase letters, lowercase letters, symbols, and numbers',
    number: 'Please enter half-width alphanumeric characters'
  }
};
